/**
 * House collection — category mosaic carousel only (filters live on collection.retail-sub-collection).
 * Scoped to [data-house-collection] / [data-house-category-nav] only.
 */
(function () {
  'use strict';

  function qs(root, sel) {
    return root.querySelector(sel);
  }
  function qsa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function refreshLazyImages(container) {
    if (!container) return;
    if (window.lazySizes && window.lazySizes.loader && typeof window.lazySizes.loader.checkElems === 'function') {
      window.lazySizes.loader.checkElems();
      return;
    }
    qsa(container, 'img.lazyload[data-src]').forEach(function (img) {
      if (img.classList.contains('lazyloaded') || img.classList.contains('lazyloading')) return;
      var src = img.getAttribute('data-src');
      if (src) img.setAttribute('src', src);
    });
  }

  function isMobileCarousel() {
    return window.matchMedia('(max-width: 767.98px)').matches;
  }

  /* ── Category navigator — Manual Product Carousel interaction (mobile) ── */
  function initCategoryNav(root) {
    if (root.__houseNavInit) return;
    root.__houseNavInit = true;

    var mosaic = qs(root, '[data-house-mosaic]');
    var controls = qs(root, '[data-house-arrows]');
    var prev = qs(root, '[data-house-arrow-prev]');
    var next = qs(root, '[data-house-arrow-next]');
    var scrollBar = qs(root, '[data-house-scroll-bar]');
    var thumb = qs(root, '[data-house-scroll-thumb]');

    if (!mosaic) return;

    function getCards() {
      return qsa(mosaic, '.house-nav__card');
    }

    function getTrackGap() {
      var style = getComputedStyle(mosaic);
      return parseFloat(style.columnGap || style.gap) || 0;
    }

    function scrollLeftForIndex(index) {
      var cards = getCards();
      if (!cards.length) return 0;
      var gap = getTrackGap();
      var left = 0;
      for (var i = 0; i < index; i++) {
        left += cards[i].offsetWidth + gap;
      }
      return left;
    }

    function getCurrentIndex() {
      var cards = getCards();
      if (!cards.length) return 0;
      var scrollLeft = mosaic.scrollLeft;
      var index = 0;
      for (var i = cards.length - 1; i >= 0; i--) {
        if (scrollLeft >= scrollLeftForIndex(i) - 4) {
          index = i;
          break;
        }
      }
      return index;
    }

    function scrollToIndex(index) {
      var cards = getCards();
      if (!cards.length) return;
      var nextIndex = Math.max(0, Math.min(cards.length - 1, index));
      mosaic.scrollTo({
        left: scrollLeftForIndex(nextIndex),
        behavior: 'smooth'
      });
    }

    function updateScrollBar() {
      if (!thumb || !scrollBar) return;
      var maxScroll = mosaic.scrollWidth - mosaic.clientWidth;
      if (maxScroll <= 0) {
        thumb.style.transform = 'translateX(0)';
        return;
      }
      var scrollRatio = mosaic.scrollLeft / maxScroll;
      var maxOffset = scrollBar.clientWidth - thumb.clientWidth;
      thumb.style.transform = 'translateX(' + scrollRatio * maxOffset + 'px)';
    }

    function updateControls() {
      var mobile = isMobileCarousel();
      var overflow = mosaic.scrollWidth > mosaic.clientWidth + 8;

      if (controls) {
        if (!mobile || !overflow) {
          controls.hidden = true;
        } else {
          controls.hidden = false;
        }
      }
      if (scrollBar) {
        if (!mobile || !overflow) {
          scrollBar.hidden = true;
        } else {
          scrollBar.hidden = false;
        }
      }

      if (!mobile) return;

      if (prev) prev.disabled = mosaic.scrollLeft <= 4;
      if (next) {
        next.disabled = mosaic.scrollLeft + mosaic.clientWidth >= mosaic.scrollWidth - 4;
      }
      updateScrollBar();
    }

    if (prev) {
      prev.addEventListener('click', function (e) {
        e.preventDefault();
        if (!isMobileCarousel()) return;
        scrollToIndex(getCurrentIndex() - 1);
      });
    }
    if (next) {
      next.addEventListener('click', function (e) {
        e.preventDefault();
        if (!isMobileCarousel()) return;
        scrollToIndex(getCurrentIndex() + 1);
      });
    }

    mosaic.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls);
    updateControls();
  }

  function boot() {
    qsa(document, '[data-house-category-nav]').forEach(initCategoryNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    qsa(e.target, '[data-house-category-nav]').forEach(initCategoryNav);
  });
})();
